import { COMMERCIAL_BEST_PLACE_ANALYTICS_EXPERIMENT } from 'shared/selectors/abExperiments/commercialBestPlaceAnalyticsExperimentSelector';
import { NEWBUILDING_BUILDER_CALL_REASONS } from 'shared/selectors/abExperiments/selectBuilderCallReasonsExperimentActive';

import { CALLTRACKING_WARNING } from '../../experiments/calltrackingWarning';
import { NEWBUILDING_OFFER_REDESIGN_EXPERIMENT, NEWBUILDING_WINNER_EXPERIMENT } from '../../selectors/abExperiments';
import { COMMERCIAL_TC_BC_BLOCK_EXPERIMENT } from '../../selectors/abExperiments/commercialTCBCBlockExperiment';
import { COMMERCIAL_UNIQUE_TO_CIAN_EXPERIMENT_V2 } from '../../selectors/abExperiments/isCommercialUniqueToCianExperimentEnabledSelector';
import { MORTGAGE_PROMO_DISCOUNT_CAMPAIGN_EXPERIMENT } from '../../selectors/abExperiments/selectMortgagePromoDiscountCampaignActive';
import { NEWBUILDINGS_TRANSPORT_INDEX_REMOVING } from '../../selectors/transportAccessibility';
import { HOUSE_CARD_URL_EXPERIMENT } from '../../utils/experiments/houseCardUrl';

export const EXPERIMENTS: string[] = [
  MORTGAGE_PROMO_DISCOUNT_CAMPAIGN_EXPERIMENT,
  HOUSE_CARD_URL_EXPERIMENT,
  CALLTRACKING_WARNING,
  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-125416, будет удалён в задаче CD-125446
   */
  COMMERCIAL_TC_BC_BLOCK_EXPERIMENT,
  NEWBUILDING_WINNER_EXPERIMENT,
  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задачах CD-144923 и CD-164185, будет удалён в задаче CD-164376
   */
  NEWBUILDINGS_TRANSPORT_INDEX_REMOVING,
  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-153172, будет удалён в задаче CD-153173
   */
  COMMERCIAL_UNIQUE_TO_CIAN_EXPERIMENT_V2,
  NEWBUILDING_OFFER_REDESIGN_EXPERIMENT,

  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-158957, будет удалён в задаче CD-159236
   */
  COMMERCIAL_BEST_PLACE_ANALYTICS_EXPERIMENT,
  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-164218, будет удалён в задаче CD-164236
   */
  NEWBUILDING_BUILDER_CALL_REASONS,
];
